<template>
  <div class="knowledge-directory-select" :class="{ disabled }">
    <el-dropdown
      trigger="click"
      id="knowledge-directory-dropdown"
      @visible-change="handleDropdownVisibleChange"
      :hide-on-click="false"
      :disabled="disabled"
    >
      <span
        :class="[
          'dropdown-trigger',
          dropdownVisible ? 'dropdown-trigger-active' : ''
        ]"
      >
        <span
          v-if="selectedNode"
          class="dropdown-content"
        >
          {{ selectedNode[displayProp] }}
        </span>
        <span
          v-else
          class="dropdown-placeholder"
        >
          {{ placeholder }}
        </span>
        <span class="dropdown-icon">
          <em
            v-show="!dropdownVisible"
            class="el-icon-arrow-down"
          ></em>
          <em
            v-show="dropdownVisible"
            class="el-icon-arrow-up"
          ></em>
        </span>
      </span>
      <el-dropdown-menu
        slot="dropdown"
        class="knowledge-directory-dropdown-menu"
      >
        <el-dropdown-item class="directory-dropdown-item">
          <el-input
              v-model="searchText"
              placeholder="搜索"
              prefix-icon="el-icon-search"
              clearable
              class="search-input"
          />
          <div class="tree-wrapper" v-loading="loading">
            <el-tree
              :data="innerTreeData"
              :node-key="valueKey"
              :default-expand-all="true"
              :props="treeProps"
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              :filter-node-method="filterNode"
              highlight-current
              ref="innerTree"
            >
              <span class="custom-tree-node" slot-scope="{ data }">
                <span class="node-label">{{ data[displayProp] }}</span>
                <span v-if="data.__checked" class="node-check">
                  <i class="el-icon-check"></i>
                </span>
              </span>
            </el-tree>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "KnowledgeDirectorySelect",
  props: {
    value: {
      type: Object,
      default: null
    },
    treeData: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '请选择知识目录'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    treeProps: {
      type: Object,
      default: () => ({
        children: 'children',
        label: 'name'
      })
    }
  },
  data() {
    return {
      dropdownVisible: false,
      innerTreeData: [],
      selectedNode: null,
      searchText:""
    }
  },
  computed: {
    displayProp() {
      return this.treeProps && this.treeProps.label ? this.treeProps.label : 'name'
    },
    valueKey() {
      return this.treeProps && this.treeProps.value ? this.treeProps.value : 'id'
    }
  },
  watch: {
    treeData: {
      handler(newVal) {
        this.innerTreeData = this.cloneTreeData(newVal || [])
        this.syncCheckedState()
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(newVal) {
        this.selectedNode = newVal
        this.syncCheckedState()
      },
      immediate: true
    },
    searchText(val) {
      this.$refs.innerTree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    cloneTreeData(list) {
      return (list || []).map(item => {
        const clone = { ...item }
        if (Array.isArray(item.children) && item.children.length) {
          clone.children = this.cloneTreeData(item.children)
        }
        return clone
      })
    },
    handleDropdownVisibleChange(val) {
      this.dropdownVisible = val
    },
    clearCheckedState(nodes) {
      (nodes || []).forEach(node => {
        this.$set(node, '__checked', false)
        if (Array.isArray(node.children) && node.children.length) {
          this.clearCheckedState(node.children)
        }
      })
    },
    syncCheckedState() {
      this.clearCheckedState(this.innerTreeData)
      if (!this.selectedNode) {
        return
      }
      const matchId = this.selectedNode[this.valueKey]
      this.markNodeChecked(this.innerTreeData, matchId)
    },
    markNodeChecked(nodes, id) {
      if (!Array.isArray(nodes) || !nodes.length || id === undefined || id === null) {
        return false
      }
      for (let i = 0; i < nodes.length; i += 1) {
        const node = nodes[i]
        if (node[this.valueKey] === id) {
          this.$set(node, '__checked', true)
          return true
        }
        if (node.children && node.children.length) {
          const found = this.markNodeChecked(node.children, id)
          if (found) {
            return true
          }
        }
      }
      return false
    },
    handleNodeClick(nodeData) {
      this.selectedNode = nodeData
      this.syncCheckedState()
      this.$emit('input', nodeData)
      this.$emit('change', nodeData)
    }
  }
}
</script>

<style scoped lang="less">
.knowledge-directory-select {
  width: 100%;

  &.disabled {
    cursor: not-allowed;
  }

  #knowledge-directory-dropdown {
    width: 100%;
  }

  .dropdown-trigger {
    display: flex;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    align-items: center;
    cursor: pointer;
    transition: border-color 0.2s;

    &-active {
      border-color: #409eff;
    }
  }

  .dropdown-content,
  .dropdown-placeholder {
    flex: 1;
    min-height: 36px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    font-size: 14px;
    color: #303133;
  }

  .dropdown-placeholder {
    color: #c0c4cc;
  }

  .dropdown-icon {
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
  }
}

.knowledge-directory-dropdown-menu {
  padding: 0 !important;
  .el-dropdown-menu__item {
    padding: 0 !important;
  }
}

.directory-dropdown-item {
  width: 420px !important;
  max-height: 350px;
  overflow: hidden;

  .tree-wrapper {
    max-height: 300px;
    overflow-y: auto;
    padding: 8px 12px;
  }

  .custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 20px);

    .node-label {
      font-size: 13px;
      color: #303133;
    }

    .node-check {
      color: #409eff;
    }
  }
}
</style>
